import { render, staticRenderFns } from "./ctaBig.vue?vue&type=template&id=38e089bc"
import script from "./ctaBig.vue?vue&type=script&lang=js"
export * from "./ctaBig.vue?vue&type=script&lang=js"
import style0 from "./ctaBig.vue?vue&type=style&index=0&id=38e089bc&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./ctaBig.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports